import { Injectable } from '@angular/core';
import { DefaultDataServiceConfig, Logger } from '@ngrx/data';
import { HttpClient } from '@angular/common/http';
import {AbstractDataServiceV2} from "../../../../../../core/service/v2/dataservice/abstractDataServiceV2";
import {InsoleElementDefinitionModel} from "../../../api/model/insoleElementDefinition.model";
import {InsoleElementDefinitionConverter} from "../../../api/model/insoleElementDefinition.converter";
import {CustomizeHttpUrlGenerator} from "../../../../../../../store/core/url/customizeHttpUrlGenerator";

@Injectable({
        providedIn: 'root'
})
export class InsoleElementDefinitionDataService extends AbstractDataServiceV2<InsoleElementDefinitionModel, InsoleElementDefinitionConverter> {
    constructor(
        http: HttpClient,
        httpUrlGenerator: CustomizeHttpUrlGenerator,
        logger: Logger,
        config: DefaultDataServiceConfig,
        converter: InsoleElementDefinitionConverter) {
        super('InsoleElementDefinition', http, httpUrlGenerator, logger, config, converter);
    }
}
